// extracted by mini-css-extract-plugin
var _1 = "nbMLwfFOWk";
export { _1 as "root" }
